import React, { useEffect, useState } from "react";
import { ReactComponent as Do } from "../../resources/do.svg";
import { ReactComponent as DoNot } from "../../resources/do-not.svg";
import BA from "../../resources/BA.png";

import img1 from "../../resources/1 Surfer (single).jpeg";
import img2 from "../../resources/2 Volleyball (single).jpeg";
import img3 from "../../resources/3 Baseball (single).jpeg";
import img4 from "../../resources/4 Tennis (single).jpeg";
import img5 from "../../resources/5 Ice (single).jpeg";
import img6 from "../../resources/6 Bikerin (single).jpeg";
import img7 from "../../resources/7 Box (single).jpeg";
import img8 from "../../resources/8 Yoga (single).jpeg";

import gallery1 from "../../resources/Basketball (Gallery).jpg";
import gallery2 from "../../resources/Futbol (Gallery).jpg";
import gallery3 from "../../resources/Fuball (Gallery).jpg";
import gallery4 from "../../resources/Cheerleader (Gallery).jpg";
import gallery5 from "../../resources/Golf (Gallery).jpg";
import gallery6 from "../../resources/Singer (Gallery).jpg";

// New Mobile Pair Imports
import gym from "../../resources/landing photos/gym.jpeg";
import gym2 from "../../resources/landing photos/gym2.jpeg";
import skateboard from "../../resources/landing photos/skateboard.jpeg";
import skateboard2 from "../../resources/landing photos/skateboard2.jpeg";
import pool from "../../resources/landing photos/pool.jpeg";
import pool2 from "../../resources/landing photos/pool2.jpeg";

const images = [img1, img2, img3, img4, img5, img6, img7, img8];

const galleryImages = [
  gallery1,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
];

const mobilePairs = [
  { left: gym, right: gym2 },
  { left: skateboard, right: skateboard2 },
  { left: pool, right: pool2 },
];

const Landing = () => {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const [mobileIndex, setMobileIndex] = useState(0);

  useEffect(() => {
    // Preload main images
    [...images, ...galleryImages].forEach((src) => {
      const image = new Image();
      image.src = src;
    });

    // Preload mobile pairs
    mobilePairs.forEach((pair) => {
      const imgLeft = new Image();
      imgLeft.src = pair.left;
      const imgRight = new Image();
      imgRight.src = pair.right;
    });

    let timeoutId;

    // Fast interval for desktop single images
    const intervalId = setInterval(() => {
      setFade(false);

      timeoutId = setTimeout(() => {
        setIndex((prev) => (prev + 1) % images.length);
        setFade(true);
      }, 250);
    }, 5000);

    // 10-second interval for mobile pairs
    const mobileIntervalId = setInterval(() => {
      setMobileIndex((prev) => (prev + 1) % mobilePairs.length);
    }, 10000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
      clearInterval(mobileIntervalId);
    };
  }, []);

  return (
    <div className="landing-page bg-light p-3 rounded">
      <div className="landing-wrapper bg-white text-dark">
        {/* ================= HEADER SECTION ================= */}
        <div className="ba-section">
          <img src={BA} alt="BA Logo" className="ba-logo" />

          <div className="landing-headline-wrapper">
            <div className="landing-headline">
              <span className="landing-green fw-bold">Bambkuss</span>{" "}
              <span className="landing-blue fw-bold">Active</span> is a social
              media network,
              <br />
              for everyone who wants to get in contact by
              <br />
              sharing <span className="fw-bold">Hobbies</span>,{" "}
              <span className="fw-bold">Activities</span> or{" "}
              <span className="fw-bold">Interests</span>!
            </div>
          </div>
        </div>

        {/* ================= MOTTO SECTION ================= */}
        <div className="motto-section">
          <div className="image-block">
            <img
              src={images[index]}
              alt={`Activity ${index + 1}`}
              className={`landing-photo ${fade ? "fade-in" : "fade-out"}`}
            />
          </div>

          <div className="motto-block-wrapper">
            <div className="motto-block">
              <p className="motto-title">Our Motto is:</p>

              <div className="motto-list">
                <p className="text-success fw-bold d-flex align-items-center">
                  <Do className="motto-icon" />
                  <span className="fst-italic"> I do the same!</span>
                </p>

                <p className="text-primary fw-bold d-flex align-items-center">
                  <Do className="motto-icon" />
                  <span className="fst-italic">
                    I would like to do the same!
                  </span>
                </p>

                <p className="text-danger fw-bold d-flex align-items-center">
                  <DoNot className="motto-icon" />
                  <span className="fst-italic"> I would not do the same!</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ================= GALLERY SECTION ================= */}
        <div className="landing-gallery">
          {galleryImages.map((photo, i) => (
            <div className="landing-gallery-pair" key={i}>
              <img
                src={photo}
                alt={`Example profile ${i + 1}`}
                className="landing-gallery-photo"
              />

              <div className="landing-gallery-symbols">
                <Do className="symbol-icon symbol-eq" />
                <DoNot className="symbol-icon symbol-neq" />
              </div>
            </div>
          ))}
        </div>

        {/* ================= MOBILE SLIDER SECTION ================= */}
        <div className="mobile-slider-container">
          <p className="mobile-slider-text">
            Show us your passion, your style, your individuality
          </p>

          <div className="mobile-slider-section">
            <img
              src={mobilePairs[mobileIndex].left}
              alt="Activity Match Left"
              className="mobile-slider-photo"
            />
            <Do className="symbol-icon symbol-eq mobile-slider-symbol" />
            <img
              src={mobilePairs[mobileIndex].right}
              alt="Activity Match Right"
              className="mobile-slider-photo"
            />
          </div>

          <p className="mobile-slider-text fw-bold">
            Find here <span className="landing-blue">Active</span> people, who says: <span className="text-success">I do the same!</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Landing;